import {
  type FlowGetProviderBlock,
  FlowGetProviderBlockSchema,
  FlowProviderIdType,
} from 'flow-schema';

import { GetProviderFormFields } from './FormFields';
import { getProviderDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getProviderConfig: BlockConfigProps<FlowGetProviderBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'provider',
  defaultConfig: {
    providerIdType: FlowProviderIdType.USER_ID,
    providerId: '',
  },
  configFields: {
    schema: FlowGetProviderBlockSchema.shape.config,
    FormFields: GetProviderFormFields,
  },
  documentationMarkdown: getProviderDocumentationMarkdown,
};
